import { render, staticRenderFns } from "./indicadores_frecuencias.vue?vue&type=template&id=edda1e58&"
import script from "./indicadores_frecuencias.vue?vue&type=script&lang=ts&"
export * from "./indicadores_frecuencias.vue?vue&type=script&lang=ts&"
import style0 from "./indicadores_frecuencias.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports